import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminCatalogo from "../pages/admin-catalogo/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin-catalogo",
    element: <AdminCatalogo />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;